/**
 * mCustomScrollbar setup
 */

$('#sidebar-scroll').mCustomScrollbar({
  axis:'y',
  theme:'my-theme',  // styled in stylesheets/components/_scrollbar.scss
  alwaysShowScrollbar: 1  // 2 to always show dot
});
